import { FC } from 'react';
import { CustomModal } from 'components';
import SuggestedAdjustmentForm from './SuggestedAdjustmentForm';
import ReviewSuggestionData from './ReviewSuggestionData';
import { AdjustmentFormData, SuggestedAdjustment } from '../payrun.model';
import { FormCloseIcon } from 'assets/icons';
import { Assignee } from 'containers/jobs/jobs.model';
import { AdjustmentSourceType } from '../constants';

interface ReviewAdjustmentSuggestionsModalProps {
  open: boolean;
  onClose: () => void;
  suggestedAdjustment: SuggestedAdjustment;
  onDiscard: (adjustmentId: string) => void;
  onDecideLater: (adjustmentData: AdjustmentFormData, adjustmentId: string, isEdited: boolean) => void;
  onAddAdjustment: (adjustmentData: AdjustmentFormData, adjustmentId: string, isEdited: boolean) => void;
  currentIndex: number;
  totalSuggestions: number;
  assignees: Assignee[];
  sourceType: AdjustmentSourceType;
  isLoading: boolean;
}

const ReviewAdjustmentSuggestionsModal: FC<ReviewAdjustmentSuggestionsModalProps> = ({
  open,
  onClose,
  suggestedAdjustment,
  onDiscard,
  onDecideLater,
  onAddAdjustment,
  currentIndex,
  totalSuggestions,
  assignees,
  sourceType,
  isLoading
}) => {
  const handleDiscard = () => {
    onDiscard(suggestedAdjustment.id.toString());
  };

  const handleDecideLater = (adjustmentData: any, isEdited: boolean) => {
    onDecideLater(adjustmentData, suggestedAdjustment.id.toString(), isEdited);
  };

  const handleAddAdjustment = (adjustmentData: any, isEdited: boolean) => {
    onAddAdjustment(adjustmentData, suggestedAdjustment.id.toString(), isEdited);
  };

  return (
    <CustomModal open={open} width="md:w-full max-w-[931px]">
      <div className="h-full p-6">
        <div className="mb-6 flex items-center justify-between">
          <h2 className="text-xl font-bold text-heading">
            Review suggestions ({currentIndex + 1} of {totalSuggestions})
          </h2>
          <FormCloseIcon className="h-6 w-6 cursor-pointer" onClick={onClose} />
        </div>
        <div className="flex h-full gap-6">
          <div className="w-1/2">
            <ReviewSuggestionData suggestedAdjustment={suggestedAdjustment} />
          </div>
          <div className="w-1/2 rounded-md border border-secondary">
            <SuggestedAdjustmentForm
              suggestedAdjustment={suggestedAdjustment}
              onDiscard={handleDiscard}
              onDecideLater={handleDecideLater}
              onAddAdjustment={handleAddAdjustment}
              sourceType={sourceType}
              assignees={assignees}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default ReviewAdjustmentSuggestionsModal;
